import React from 'react';
import { observer } from 'mobx-react';
import ContentHistoryService from '../services/ContentHistoryService';
import { toJS } from 'mobx';
import KpiDialogHistory from '../../commons/KpiDialogHistory';

const ContentHistoryDialogContainer = () => (
  <KpiDialogHistory
    isOpen={ContentHistoryService.isOpen}
    onCancel={ContentHistoryService.closeDialog}
    data={toJS(ContentHistoryService.data)}
    isLoading={ContentHistoryService.fetch.fetching}
    indicator={ContentHistoryService.indicator}
    valueFormatter={ContentHistoryService.getFormattedValue}
    indicatorFormatter={ContentHistoryService.getFormattedIndicator}
  />
);

export default observer(ContentHistoryDialogContainer);
